import {
  IExtendExperienceParams,
  IQueryIdentifierError,
  IQueryIdentifierResponse
} from '@aqx-core/common/api/experience/model';
import { request } from '@aqx-core/common/request';

export default {
  extendExperienceThroughSalesforce: (params: IExtendExperienceParams) =>
    request.patch<IQueryIdentifierResponse, IQueryIdentifierError>('/api/auth/v1/experience/extend', undefined, {
      params
    }),
  queryExperienceIdentifier: (params: IExtendExperienceParams) =>
    request.get<IQueryIdentifierResponse>('/api/auth/v1/experience/query/identifier', { params })
};
